export default __webpack_public_path__ + "static/media/software-tester.df568f2f.gif";